import { render, staticRenderFns } from "./Dokumen.vue?vue&type=template&id=4c26fb76&"
import script from "./Dokumen.vue?vue&type=script&lang=js&"
export * from "./Dokumen.vue?vue&type=script&lang=js&"
import style0 from "./Dokumen.vue?vue&type=style&index=0&id=4c26fb76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports